// The Stimulus manifest, maintained by hand: register a controller here when
// you add one. `bin/rails stimulus:manifest:update` regenerates the top-level
// entries but does not know about the free_tools/ directory.

import { application } from "./application"

import OutboundController from "./outbound_controller"
application.register("outbound", OutboundController)

import JobsFilterController from "./jobs_filter_controller"
application.register("jobs-filter", JobsFilterController)

// The fourteen calculators are a bundle of their own, free_tools.js, that
// only their pages include. Nothing else the site serves carries their code.
